import React from "react";
import { Wrapper } from "../../shared/Wrapper";
import { ImageUploader } from "../../../../../../boxes/ImageUploader/ImageUploader";
import { usePublicSurveyUploadFileMutation } from "../../../../../../api/surveys/usePublicSurveyUploadFileMutation";
import { uiNotification } from "../../../../../../services/UINotificationService";
import { useAppTranslation } from "../../../../../../i18n/useAppTranslation";
import { useSurvey } from "../../../../hooks/useSurvey";
import { fileUtil } from "../../../../../../utilities/file";

/**
 * @param {{
 *  id: number;
 *  question: string;
 *  description?: string;
 *  required?: boolean;
 *  value: string;
 *  onChange: (value: string) => void;
 * }} param0
 */
export function QuestionFile({
  id,
  question,
  description,
  required,
  value,
  onChange,
}) {
  var { tSurvey: t } = useAppTranslation.Survey();
  var { data: survey } = useSurvey();

  var { mutate, isLoading } = usePublicSurveyUploadFileMutation({
    onSuccess: ({ url }) => {
      onChange(url);
    },
    onError: () => {
      uiNotification.error(t("error.file_upload"));
    },
  });

  var handlePick = async (e) => {
    var raw = e.target?.files?.[0];

    if (!raw.type.includes("image/")) {
      uiNotification.error(t("error.file_type"));
      return;
    }

    var file = await fileUtil.read(e.target?.files?.[0], {
      method: "dataUrl",
    });

    if (survey?.patientId && survey?.accountId) {
      mutate({
        file,
        patientId: survey.patientId,
        accountId: survey.accountId,
      });
    } else {
      uiNotification.error(t("error.file_upload"));
    }
  };

  return (
    <Wrapper title={question} description={description} required={required}>
      <ImageUploader
        name={`surveyFile-${id}`}
        value={value}
        isLoading={isLoading}
        onChange={handlePick}
        onRemove={() => onChange()}
      />
    </Wrapper>
  );
}
